//Library imports
import React from "react";
import styled from "styled-components";
import { Col, Row } from "antd";
//Local imports
import PillTabs from "modules/Common/PillTabs";
import AudiencenSearch from "../AudiencenSearch";
import ListCard from "modules/Campaigns/Shared/ListCard";
import AddCampaign from "modules/Campaigns/Shared/AddCampaign";
import EditItemName from "modules/Common/Components/EditItemName";

interface AudienceAccountsProps {}

const AudienceAccounts: React.FC<AudienceAccountsProps> = (props) => {
  return (
    <Wrapper>
      {/* <Row gutter={24}>
        <Col className="gutter-row mb-2" span="24">
          <EditItemName itemName="Accounts" nonEditable={true} />
        </Col>
      </Row>
      <AudiencenSearch
        ShowSearchIcon={false}
        Placeholder="Search Companies & accounts..."
      />
      <PillTabs /> */}
      <h3>My Accounts</h3>
      <Row gutter={56}>
        <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
          <ListCard />
        </Col>
        <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
          <ListCard />
        </Col>
        <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
          <ListCard />
        </Col>
        <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
          <ListCard />
        </Col>
        <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
          <ListCard />
        </Col>
        <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
          <ListCard />
        </Col>
        <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
          <ListCard />
        </Col>
        <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
          <ListCard />
        </Col>
        <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
          <ListCard />
        </Col>
        <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
          <ListCard />
        </Col>
        <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
          <AddCampaign />
        </Col>
      </Row>
    </Wrapper>
  );
};

export default AudienceAccounts;

const Wrapper = styled.div``;
